jQuery(document).ready(function() {
    jQuery("#shops-select-country").on('change', function() {
        console.log(jQuery("#shops-select-country").find(":selected").val());

        jQuery.ajax({
            type: "POST",
            dataType: "html",
            url: localize.ajaxurl,
            data: {
                country: jQuery("#shops-select-country").find(":selected").val(),
                action: 'load_shops_ajax',
            },
            success: function(data) {
                jQuery(".store-response").html("");
                jQuery(".store-response").append(data);
            }
        });
    });
});